if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.productId = this.getAttribute('data-product-id');
    }
  
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
  
    showActiveMedia() {
      const activeMediaId = this.openedBy.getAttribute("data-media-id");
      const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
  
      if (!activeMedia) {
        console.warn(`No se encontró medio con id ${activeMediaId} para el producto ${this.productId}. Mostrando el primer medio disponible.`);
        const firstMedia = this.querySelector('[data-media-id]');
        if (firstMedia) {
          firstMedia.classList.add('active');
          firstMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          console.error(`No se encontraron medios en el modal para el producto ${this.productId}.`);
          return;
        }
      } else {
        this.querySelectorAll(`[data-media-id]`).forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      const container = this.querySelector('[role="document"]');
      if (container) {
        const activeElement = activeMedia || this.querySelector('[data-media-id]');
        if (activeElement) {
          container.scrollLeft = (activeElement.offsetWidth - container.clientWidth) / 2;
          container.scrollTop = (activeElement.offsetHeight - container.clientHeight) / 2;
        }
      }
    }
  });
}
